function PopoverCtrl($q, $element, $window, $timeout, $scope, popoverService, popoverConfig) {
  const ctrl = this;
  let resizeHandler = null;
  let resizeTarget = null;
  let resizeRafId = null;
  ctrl.$onInit = function () {
    const popoverShowOnLoad = ctrl.popoverShowOnLoad(),
      popoverOverlayEnabled = ctrl.popoverOverlayEnabled(),
      popoverIsFixed = ctrl.popoverIsFixed(),
      popoverIsCanHover = ctrl.popoverIsCanHover();
    ctrl.popoverShowOnLoad = popoverShowOnLoad ? popoverShowOnLoad : popoverConfig.popoverShowOnLoad;
    ctrl.popoverOverlayEnabled = popoverOverlayEnabled ? popoverOverlayEnabled : popoverConfig.popoverOverlayEnabled;
    ctrl.popoverIsFixed = popoverShowOnLoad ? popoverIsFixed : popoverConfig.popoverIsFixed;
    ctrl.popoverIsCanHover = popoverIsCanHover ? popoverIsCanHover : popoverConfig.popoverIsCanHover;
    ctrl.popoverShowOne = ctrl.popoverShowOne ? ctrl.popoverShowOne : popoverConfig.popoverShowOne;
    ctrl.popoverShowDelay = ctrl.popoverShowDelay ? ctrl.popoverShowDelay : popoverConfig.popoverShowDelay;
    ctrl.popoverShowCross = ctrl.popoverShowCross ? ctrl.popoverShowCross : popoverConfig.popoverShowCross;
    popoverService.addStorage(ctrl.id, ctrl);
  };
  ctrl.updatePosition = function (targetElement) {
    ctrl.position = popoverService.getPosition($element[0], targetElement || ctrl.controlElement[0], ctrl.popoverPosition, ctrl.popoverIsFixed);
  };
  function attachResizeListener(targetElement) {
    if (ctrl.popoverIsFixed !== true || resizeHandler != null) return;
    resizeTarget = targetElement;
    resizeHandler = () => {
      if (resizeRafId != null) return;
      resizeRafId = $window.requestAnimationFrame(() => {
        resizeRafId = null;
        if (!ctrl.popoverIsShow || ctrl.popoverCustomStyles) return;
        ctrl.updatePosition(resizeTarget);
        ctrl.popoverPosition = ctrl.position.position;
        $scope.$applyAsync();
      });
    };
    $window.addEventListener('resize', resizeHandler);
  }
  function detachResizeListener() {
    if (resizeHandler != null) {
      $window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
      resizeTarget = null;
    }
    if (resizeRafId != null) {
      $window.cancelAnimationFrame(resizeRafId);
      resizeRafId = null;
    }
  }
  ctrl.active = function (targetElement) {
    if (ctrl.popoverShowOne === true && $window.localStorage.getItem(ctrl.id)) {
      return $q.resolve('Popover show is one');
    }
    const _open = () => {
      ctrl.popoverIsShow = true;
      $element[0].classList.add('active');
      if (!ctrl.popoverCustomStyles) {
        ctrl.updatePosition(targetElement);
        ctrl.popoverPosition = ctrl.position.position;
      }
      attachResizeListener(targetElement);
      if (ctrl.popoverOverlayEnabled === true) {
        popoverService.showOverlay(ctrl.id);
      }
      if (ctrl.popoverOnOpen) {
        ctrl.popoverOnOpen();
      }
      return ctrl;
    };
    if (ctrl.popoverShowDelay > 0) {
      return $timeout(() => _open(), ctrl.popoverShowDelay);
    }
    return $q.resolve(_open());
  };
  ctrl.deactive = function () {
    detachResizeListener();
    ctrl.popoverIsShow = false;
    $element[0].classList.remove('active');
    if (ctrl.popoverShowOne === true) {
      $window.localStorage.setItem(ctrl.id, true);
    }
    if (ctrl.popoverOverlayEnabled === true) {
      popoverService.getPopoverOverlay().then(overlayScope => {
        overlayScope.overlayHide();
      });
    }
    if (ctrl.popoverOnClose) {
      ctrl.popoverOnClose();
    }
  };
  ctrl.$onDestroy = function () {
    detachResizeListener();
  };
  ctrl.toggle = function () {
    if (ctrl.popoverIsShow === true) {
      ctrl.deactive();
    } else {
      ctrl.active();
    }
  };
  ctrl.getClasses = function () {
    const result = [];
    result.push(`adv-popover-position-${ctrl.popoverPosition}`);
    if (ctrl.popoverIsFixed === true) {
      result.push('adv-popover-fixed');
    }
    return result;
  };
}
PopoverCtrl.$inject = ["$q", "$element", "$window", "$timeout", "$scope", "popoverService", "popoverConfig"];
export default PopoverCtrl;